export const config = {
  cognito: {
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
    region: import.meta.env.VITE_COGNITO_REGION || 'us-east-1',
  },
  api: {
    endpoint: (import.meta.env.VITE_API_ENDPOINT || 'http://localhost:3001').replace(/\/$/, '') + '/v1',
  },
  ws: {
    endpoint: import.meta.env.VITE_WS_ENDPOINT || '',
  },
};
